export const PORTFOLIO_LIST_CONFIG = {
    name            : 'Task list',
    menuName        : 'List',
    icon            : 'i5-tasks',
    // iconLight       : 'i5-tasks-light',
    image           : 'list',
    iconSvg         : 'isvg-view-list',
    url             : 'list',
    stringId        : 'tasks_list',
    description     : 'List of project/folder tasks grouped by status, user, or other attributes.'
}
